import { Trans, useTranslation } from '@lyearn/i18n';
import { AlertDialog } from '@lyearn/molecules';
import { Typography } from '@lyearn/ui';

type Props = {
  name: string;
  open: boolean;
  onClick: () => void;
  onClose: () => void;
};

const ForceCompleteAlert = (props: Props) => {
  const { name, open, onClick, onClose } = props;

  const { t } = useTranslation();
  return (
    <AlertDialog
      header={{
        title: t('Journey:ForceCompleteHeaderTitle'),
        description: (
          <Trans
            components={{
              strong: <Typography className="text-text-secondary" variant="label-02" />,
            }}
            i18nKey="Journey:ForceCompleteHeaderDescription"
            values={{ name }}
          />
        ),
      }}
      open={open}
      primaryAction={{ label: t('Common:Actions.ForceComplete'), onClick }}
      onClose={onClose}
    />
  );
};

export default ForceCompleteAlert;
